import * as React from "react";
import { StyledTitle } from "./styles";

const NoMatch: React.FC = () => {
  return <StyledTitle>Page not found</StyledTitle>;
};

export default NoMatch;
